import { __assign, __awaiter, __extends, __generator } from "tslib";
import { SubmitTicket } from './submit-ticket/submit-ticket.comp';
import { CustomField } from './custom-fields/custom-field';
import * as React from 'react';
import { namespacedClassnames } from '../utils';
import { calcDirection } from '../utils/calc-direction';
import { escapeHtml } from '@wix/answers-lib';
import { isFeatureEnabled } from '@wix/answers-experiments';
var ContactForm = /** @class */ (function (_super) {
    __extends(ContactForm, _super);
    function ContactForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialState = {
            ticketFormData: { fullname: '', email: '', title: '', description: '', attachments: [] },
            isLoading: false,
            captchaToken: '',
            requireUserInfo: !_this.props.user,
            customFieldsValuesMap: {},
            suggestedArticleSelected: false
        };
        _this.state = _this.initialState;
        _this.compTranslate = function (key, params) { return _this.props.translate("common.contact-form." + key, params); };
        _this.maybeLogEvent = function (eventName, data) {
            try {
                if (_this.props.logger) {
                    var _a = _this.state.ticketFormData, title = _a.title, description = _a.description, attachments = _a.attachments;
                    var isAfterSuggestion = _this.state.suggestedArticleSelected;
                    if (eventName === 'suggestedArticleSelected' && data.article) {
                        _this.props.logger.suggestedArticleSelected({ title: title, description: description, attachments: attachments, isAfterSuggestion: isAfterSuggestion }, data.article);
                    }
                    else if (eventName === 'validationError' && data.invalidFields) {
                        _this.props.logger.validationError({ title: title, description: description, attachments: attachments, isAfterSuggestion: isAfterSuggestion }, data.invalidFields);
                    }
                    else if (eventName === 'submitSuccess') {
                        _this.props.logger.submitSuccess({ title: title, description: description, attachments: attachments, isAfterSuggestion: isAfterSuggestion }, data.ticketId || '');
                    }
                    else if (eventName !== 'validationError' && eventName !== 'suggestedArticleSelected') {
                        _this.props.logger[eventName]({ title: title, description: description, attachments: attachments, isAfterSuggestion: isAfterSuggestion });
                    }
                }
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error('Error logging event', e);
            }
        };
        _this.sendFormDataOnChange = function () {
            var _a = _this, state = _a.state, props = _a.props;
            if (props.onFieldsChange) {
                var formData = __assign(__assign({}, state.ticketFormData), { customFields: state.customFieldsValuesMap });
                props.onFieldsChange(formData);
            }
        };
        _this.isInvalidField = function (field, values) {
            if (!values[field.name]) {
                return true;
            }
            if (!field.multiLevelData) {
                return false;
            }
            var multilevelFieldValue = values[field.name];
            var multilevelFieldValues = String(multilevelFieldValue).includes('|') ?
                multilevelFieldValue.split('|') : [multilevelFieldValue];
            var lastLevelChildren = field.multiLevelData.values;
            multilevelFieldValues.forEach(function (value) {
                var nextLevel = lastLevelChildren.find(function (levelValue) { return levelValue.value === value; });
                lastLevelChildren = nextLevel.children;
            });
            return !!lastLevelChildren && !!lastLevelChildren.length;
        };
        // TODO - improve custom fields validation
        _this.areCustomFieldsValid = function () {
            var mandatoryFields = _this.props.customFields.filter(function (field) { return !!field.mandatory; });
            var emptyFields = mandatoryFields.filter(function (field) { return _this.isInvalidField(field, _this.state.customFieldsValuesMap); });
            var maybeValidationError = _this.props.customFields.some(function (cf) {
                var fieldValue = _this.state.customFieldsValuesMap[cf.name];
                return cf.validator && cf.validator(fieldValue);
            });
            if ((emptyFields.length || maybeValidationError) && _this.state.conditionalCustomFieldsHideErrors) {
                _this.setState({ conditionalCustomFieldsHideErrors: false });
            }
            var result = !emptyFields.length && !maybeValidationError;
            return result;
        };
        _this.onTicketDataChange = function (ticketFormData) {
            _this.setState({ ticketFormData: ticketFormData }, _this.sendFormDataOnChange);
        };
        _this.onCaptchaTokenChange = function (captchaToken) {
            _this.setState({ captchaToken: captchaToken });
        };
        _this.onSubmit = function (captcha) { return __awaiter(_this, void 0, void 0, function () {
            var state, user, splitFullName, companyId, getFirstName, getLastName, displayedCustomFieldsIds, displayedCustomFieldsData, maybeDisplayedCustomFieldsValuesMap, contatFormSubmitData, ticketId, e_1;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        state = this.state;
                        user = this.props.user;
                        splitFullName = this.state.ticketFormData.fullname.split(' ');
                        companyId = state.ticketFormData.companyId;
                        getFirstName = function () { return splitFullName.length > 1 ? splitFullName.slice(0, -1).join(' ') : splitFullName[0]; };
                        getLastName = function () { return splitFullName.length > 1 ? splitFullName.slice(-1).join(' ') : null; };
                        displayedCustomFieldsIds = this.props.customFields.map(function (field) { return field.name; });
                        displayedCustomFieldsData = Object.keys(this.state.customFieldsValuesMap)
                            .filter(function (key) { return displayedCustomFieldsIds.indexOf(key) !== -1; })
                            .reduce(function (obj, key) {
                            obj[key] = _this.state.customFieldsValuesMap[key];
                            return obj;
                        }, {});
                        maybeDisplayedCustomFieldsValuesMap = this.props.conditionalCustomFields ?
                            displayedCustomFieldsData : state.customFieldsValuesMap;
                        contatFormSubmitData = __assign({ firstName: user ? user.firstName : getFirstName(), lastName: user ? user.lastName : getLastName(), email: user ? user.email : state.ticketFormData.email, title: state.ticketFormData.title, description: escapeHtml(state.ticketFormData.description), customFieldsValuesMap: maybeDisplayedCustomFieldsValuesMap, attachments: state.ticketFormData.attachments, captchaToken: captcha || state.captchaToken, useCaptchaV3: isFeatureEnabled('ReCaptchaV3') }, (companyId ? { companyId: companyId } : {}));
                        if ((_a = this.state.ticketFormData.ccRecipients) === null || _a === void 0 ? void 0 : _a.length) {
                            contatFormSubmitData.ccRecipients = this.state.ticketFormData.ccRecipients;
                        }
                        this.maybeLogEvent('submit', {});
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.onSubmit(contatFormSubmitData)];
                    case 2:
                        ticketId = _b.sent();
                        this.maybeLogEvent('submitSuccess', { ticketId: ticketId });
                        this.setState(this.initialState);
                        return [2 /*return*/, Promise.resolve()];
                    case 3:
                        e_1 = _b.sent();
                        this.maybeLogEvent('submitFailure', {});
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onCustomFieldChange = function (name, value) {
            var _a;
            if (_this.state.conditionalCustomFieldsHideErrors === false && !!value) {
                _this.setState({ conditionalCustomFieldsHideErrors: true });
            }
            _this.setState({
                customFieldsValuesMap: __assign(__assign({}, _this.state.customFieldsValuesMap), (_a = {}, _a[name] = value, _a)),
            }, _this.sendFormDataOnChange);
        };
        _this.onCancel = function () {
            _this.maybeLogEvent('cancel', {});
            if (_this.props.onCancel) {
                _this.setState(_this.initialState);
                _this.props.onCancel();
            }
        };
        _this.renderCustomFields = function (formIsInvalid) {
            return _this.props.customFields.map(function (customField, idx) {
                var fieldValue = _this.state.customFieldsValuesMap[customField.name];
                var customFieldKey = customField.id + "-" + idx;
                var maybeShowError = !_this.state.conditionalCustomFieldsHideErrors && formIsInvalid;
                var maybeValidationError = customField.validator && customField.validator(fieldValue);
                return (React.createElement(CustomField, { key: customFieldKey, customField: customField, fieldValue: fieldValue, onCustomFieldChange: _this.onCustomFieldChange, showError: maybeShowError, validationError: maybeValidationError, locale: _this.props.locale, t: _this.props.translate }));
            });
        };
        _this.onRequestSuggestedArticles = function () {
            var _a = _this.state.ticketFormData, title = _a.title, description = _a.description;
            return _this.props.onGetSuggestedArticles(title, description, _this.state.customFieldsValuesMap);
        };
        _this.logSuggestedArticleClick = function (article) { return _this.maybeLogEvent('suggestedArticleSelected', { article: article }); };
        _this.onSuggestedArticleClick = function (article) {
            _this.setState({ suggestedArticleSelected: true });
            var currentFormData = __assign(__assign({}, _this.state.ticketFormData), { customFields: _this.state.customFieldsValuesMap });
            _this.logSuggestedArticleClick(article);
            if (_this.props.onSuggestedArticleClick) {
                _this.props.onSuggestedArticleClick(article, currentFormData);
            }
        };
        _this.onValidationError = function (invalidFields) { return _this.maybeLogEvent('validationError', { invalidFields: invalidFields }); };
        return _this;
    }
    ContactForm.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ requireUserInfo: !nextProps.user });
        if (this.props.initialFieldData !== nextProps.initialFieldData) {
            this.normalizeFormData(nextProps);
        }
    };
    ContactForm.prototype.normalizeFormData = function (props) {
        var initialFieldData = props.initialFieldData, customFields = props.customFields;
        var fullname = initialFieldData.fullname || '';
        var email = initialFieldData.email || '';
        var title = initialFieldData.title || '';
        var description = initialFieldData.description || '';
        var attachments = initialFieldData.attachments || [];
        var customFieldsValuesMap = customFields.reduce(function (res, curr) {
            var _a;
            var fieldVal = initialFieldData.customFields[curr.name];
            return __assign(__assign({}, res), (_a = {}, _a[curr.name] = fieldVal, _a));
        }, {});
        this.setState({
            ticketFormData: __assign(__assign({}, this.state.ticketFormData), { fullname: fullname, email: email, title: title, description: description, attachments: attachments }),
            customFieldsValuesMap: customFieldsValuesMap
        });
    };
    ContactForm.prototype.componentDidMount = function () {
        this.normalizeFormData(this.props);
        if (this.props.conditionalCustomFields) {
            this.setState({ conditionalCustomFieldsHideErrors: false });
        }
    };
    ContactForm.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.conditionalCustomFields && this.props.conditionalCustomFields) {
            this.setState({ conditionalCustomFieldsHideErrors: false });
        }
    };
    ContactForm.prototype.render = function () {
        var props = this.props;
        var _a = this.state, captchaToken = _a.captchaToken, ticketFormData = _a.ticketFormData;
        var classNames = namespacedClassnames('contact-form-container', calcDirection(props.locale));
        var captchaProps = {
            captchaToken: captchaToken,
            onCaptchaTokenChange: this.onCaptchaTokenChange,
            data: props.reCaptchaData,
        };
        var submitTicketProps = {
            ticketFormData: ticketFormData,
            captchaProps: captchaProps,
            hideRecaptchaBadge: this.props.hideRecaptchaBadge || isFeatureEnabled('ReCaptchaV3'),
            translate: this.compTranslate,
            renderCustomFields: this.renderCustomFields,
            onCancel: props.onCancel ? this.onCancel : undefined,
            isUserAnonymous: !props.user,
            onGetSuggestedArticles: this.onRequestSuggestedArticles,
            onSubmit: this.onSubmit,
            onAttachmentUpload: props.onAttachmentUpload,
            areCustomFieldsValid: this.areCustomFieldsValid,
            onChange: this.onTicketDataChange,
            onSuggestedArticleClick: this.props.onSuggestedArticleClick && this.onSuggestedArticleClick,
            logSuggestedArticleClick: this.logSuggestedArticleClick,
            onValidationError: this.onValidationError,
            suggestedArticlesUnderSubject: props.suggestedArticlesUnderSubject,
            addCCEmail: this.props.addCCEmail,
            partnerCompanyField: this.props.partnerCompanyField,
            allowedFileTypes: props.allowedFileTypes,
            enableEmailConfirmation: props.enableEmailConfirmation
        };
        return (React.createElement("div", { className: classNames },
            React.createElement(SubmitTicket, __assign({}, submitTicketProps))));
    };
    return ContactForm;
}(React.Component));
export { ContactForm };
//# sourceMappingURL=contact-form.comp.js.map